import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import PremissionTable from '../Table/PremissionTable';

function ManagePerm(props) {
    const history = useHistory();

    // useEffect(() => {
    // });

    return (
        <div>
            <div style={{ textAlign: 'center', fontFamily: 'Rubik' }}>
                <h1> SUPER ADMIN ROLE MATRIX</h1>
            </div>
            <PremissionTable />
        </div>
    );
}

export default ManagePerm;
